import { Modal, Result } from "antd"
import { QuestionOutlined } from '@ant-design/icons';
import { FormActionButtons } from "src/components/FormActionButtons";
import { generateRandomPassword, stringToBase64 } from "src/common/util";
import { SystemConstants } from "src/common/constants";
import { useDispatch, useSelector } from "react-redux";
import { UserError, UserErrorOrigin } from "../state/types";
import { RootState } from "src/state/reducer";
import { serviceLoading } from "src/common/apiLoader/state/selection";
import { UPDATE_USER_PASSWORD_API } from "../state/actionTypes";
import { updateUserPasswordApi } from "../state/action";
import { User } from "src/common/models/user";
import { useEffect, useState } from "react";
import { SystemDescriptions } from "src/common/descriptions";

interface Props {
    user: User
    open: boolean
    onAccept: VoidFunction
    onCancel: (errorMessage?: string) => void
}

interface ReduxProps {
    error?: UserError
    isUpdatingUserPassword: boolean
    user?: User
    updatetUserPasswordSuccess: boolean
}

export const UserPasswordAssignation = (props: Props) => {
    const dispatch = useDispatch()

    const [newPassword] = useState(generateRandomPassword(SystemConstants.PASSWORD_LENGTH))
    const [actionButtonClicked, setActionButtonClicked] = useState<boolean>(false)

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        isUpdatingUserPassword: serviceLoading(state, [UPDATE_USER_PASSWORD_API]),
        error: state.user.error,
        user: state.security.user,
        updatetUserPasswordSuccess: state.user.updatetUserPasswordSuccess,
    }))

    const descriptios = SystemDescriptions.PAGES.USER.CREATE
    const commonDescriptions = SystemDescriptions.PAGES.COMMON

    useEffect(() => {
        if (reduxProps.error && reduxProps.error.type === UserErrorOrigin.UPDATE_USER_PASSWORD) {
            props.onCancel(reduxProps?.error?.detail?.message || commonDescriptions.FORM.UNKNOWN_ERROR)
        }
    }, [reduxProps.error])

    useEffect(() => {
        if (reduxProps.updatetUserPasswordSuccess && actionButtonClicked) {
            props.onAccept()
        }
    }, [reduxProps.updatetUserPasswordSuccess])

    const handleAccept = () => {
        setActionButtonClicked(true)
        dispatch(updateUserPasswordApi({
            processType: "ASSIGN",
            newPassword: stringToBase64(newPassword),
            userIdProcess: props.user.id!,
        }))
    }

    const renderButtonsSection = () => {
        return <FormActionButtons
            cancelText={commonDescriptions.CANCEL}
            actionText={commonDescriptions.SAVE}
            onCancel={() => props.onCancel()}
            onAccept={handleAccept}
            actionLoading={reduxProps.isUpdatingUserPassword}
        />
    }

    return (
        <Modal
            title={''}
            centered
            open={props.open}
            onCancel={() => props.onCancel()}
            width={500}
            onOk={props.onAccept}
            okText={commonDescriptions.SAVE}
            cancelText={commonDescriptions.CANCEL}
            footer={<></>}
            closable={false}
            zIndex={1200}
            getContainer={false}
        >
            <Result
                icon={<QuestionOutlined />}
                title={newPassword}
                subTitle={`${descriptios.MORE_OPTIONS.PASSWORD_ASSIGN_DESCRIPTION} ${props.user.username}`}
                extra={[
                    renderButtonsSection(),
                ]}
            />
        </Modal>
    )
}
